import { useEffect, useMemo, useState } from "react";
import { Appointment } from "@elixir/types";
import useAllQueuesQuery from "../apis/tryst/get-all-queues";
import useGetQueueConfig from "../apis/tryst/get-queue-config";
import useQueueStore from "../stores/queue-store";
import { isSameDay } from "@elixir/utils";

export default function useCanShowOnboardingArrows() {
  const { data: queueData, isLoading: isLoadingQueueData } = useAllQueuesQuery({
    queueType: "all",
  });
  const { data: queueConfigData } = useGetQueueConfig();
  const { workflow_views } = queueConfigData?.data || {};
  const selectedDate = useQueueStore((state) => state.selectedDate);
  const [canShow, setCanShow] = useState(false);

  const isSelectedDateToday = useMemo(() => {
    if (!selectedDate) return false;
    return isSameDay(selectedDate, new Date());
  }, [selectedDate]);

  const queueAptsCount = useMemo(() => {
    if (!queueData || !queueConfigData) return -1;
    const apts: Set<Appointment> = new Set();
    const viewsToAggregate =
      workflow_views
        ?.filter((view) => view.includeInAgg)
        ?.map((view) => view.viewId) || [];
    viewsToAggregate.forEach((view) => {
      view && queueData?.[view]?.forEach((apt) => apts.add(apt));
    });
    return Array.from(apts).length;
  }, [queueData, queueConfigData, workflow_views]);

  useEffect(() => {
    if (isLoadingQueueData || !isSelectedDateToday) {
      setCanShow(false);
      return;
    }
    const timer = setTimeout(() => {
      setCanShow(queueAptsCount === 0);
    }, 1000);
    return () => clearTimeout(timer);
  }, [isLoadingQueueData, queueAptsCount, isSelectedDateToday]);

  return canShow;
}
